// eslint-disable-next-line no-unused-vars
function getAliCloudShield(cb: (data: unknown) => void) {
  const nc_token = [
    'FFFF00000000017C327D',
    new Date().getTime(),
    Math.random(),
  ].join(':');
  if (window.NoCaptcha) {
    const nc = window.NoCaptcha.init({
      renderTo: '#nc',
      // appkey: 'FFFF00000000017C327D',
      appkey: 'FFFF0N5N000000006148',
      scene: 'nc_login_h5',
      token: nc_token,
      trans: { key1: 'code200' },
      elementID: ['usernameID'],
      is_Opt: 0,
      language: 'cn',
      timeout: 10000,
      retryTimes: 5,
      errorTimes: 5,
      inline: false,
      apimap: {},
      bannerHidden: false,
      initHidden: false,
      callback: function (data: any) {
        console.log(data);
        data.nc_token = nc_token;
        cb && cb(data);
      },
      error: function (s: any) {
        console.log(s);
        cb &&
          cb({
            type: 'error',
          });
      },
    });
    window.NoCaptcha.setEnabled(true);
    nc.reset(); // 请务必确保这里调用一次reset()方法
    window.NoCaptcha.upLang('cn', {
      LOADING: '加载中...', // 加载
      SLIDER_LABEL: '请向右滑动验证', // 等待滑动
      CHECK_Y: '验证通过', // 通过
      ERROR_TITLE: '非常抱歉，这出错了...', // 拦截
      CHECK_N: '验证未通过', // 准备唤醒二次验证
      OVERLAY_INFORM: '经检测你当前操作环境存在风险，请输入验证码', // 二次验证
      TIPS_TITLE: '验证码错误，请重新输入', // 验证码输错时的提示
    });
  }
}

export { getAliCloudShield };
